import apiFetch from '../apiFetch'

export default function (values, token) {	
	//Creamos temporal con los datos datos del análisis
	return apiFetch({endPoint: 'MagavisionML/crearDatosML', method: 'POST', body: values, token:token})		
}
